export const stringAvatar = name => {
    return {
        sx: {
            bgcolor: stringToColor(name),
            fontSize: 16,
            width: 30,
            height: 30,
        },
        children: getFirstAndLast(name),
    }
}

export const getFirstAndLast = str => {
    // Get the first and last characters of the string
    const firstChar = str.charAt(0);
    const lastChar = str.charAt(str.length - 1);

    // Convert the characters to uppercase
    const firstCharUpper = firstChar.toUpperCase();
    const lastCharUpper = lastChar.toUpperCase();

    // Return the first and last characters in uppercase
    return firstCharUpper + lastCharUpper;
}

export const stringToColor = string => {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
    return color;
}

export const sizeToColor = size => {
    if (size === 'S') return '#00FF00'
    if (size === 'M') return '#FFA500'
    if (size === 'L') return '#FF0000'
    if (size === 'XL') return '#8b0000'
}

export const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", { month: "short", day: "numeric" });
};

export const getFileBase64 = (file, callback) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    // Since FileReader is asynchronous,
    // we need to pass data back.
    reader.onload = () => callback(reader.result);
    // TODO: catch an error
    reader.onerror = error => { };
};

export const imageUploadCallback = file => new Promise(
    (resolve, reject) => getFileBase64(
        file,
        data => resolve({ data: { link: data } })
    )
);

export const download = (dataurl, filename, suffix) => {
    const link = document.createElement("a");
    link.href = dataurl;
    link.download = filename + '.' + suffix;
    link.click();
}

const formatDateSC = (value) => {
    return new Date(value).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}